const defaultOptions = {
    regexp: /[<>="']/g,
    errorMessage: 'Forbidden characters: {{forbidden}}',
};
const validateInput = (input = '', options = defaultOptions) => {
    const opts = Object.assign(Object.assign({}, defaultOptions), options);
    const stringInput = input || '';
    const matchedChars = [...new Set(stringInput.match(opts.regexp))].join('');
    return opts.regexp.test(stringInput)
        ? opts.errorMessage.replace(/{{forbidden}}/, matchedChars)
        : undefined;
};
export const validateForbiddenChars = (input) => validateInput(input);
export const getValidateForbiddenCharsFn = (options) => {
    return (input) => validateInput(input, options);
};
